import Tooltip from "../../../../components/Tooltip";
import ToggleButton from "../../../../components/ToggleButton";
import React from "react";
import { Box } from "@mui/material";
import { TAverageData } from "../../../../features/productAnalyzer/productAnalyzer.types";

export interface IDurationOption {
  tooltip: string;
  label: string;
  id: string;
  range: string;
  avgId: keyof TAverageData;
  days: number;
}

export const DURATION_OPTIONS: IDurationOption[] = [
  {
    tooltip: "Current",
    label: "Current",
    id: "Current",
    range: "",
    avgId: "avgCurrent",
    days: 0,
  },
  {
    tooltip: "Average 30 Days",
    label: "30",
    id: "Days30",
    range: "30",
    avgId: "avg30",
    days: 30,
  },
  {
    tooltip: "Average 90 Days",
    label: "90",
    id: "Days90",
    range: "90",
    avgId: "avg90",
    days: 90,
  },
  {
    tooltip: "Average 180 Days",
    label: "180",
    id: "Days180",
    range: "180",
    avgId: "avg180",
    days: 180,
  },
  {
    tooltip: "Lifetime",
    label: "All",
    id: "All",
    range: "All",
    avgId: "avgAll",
    days: 0,
  },
];

interface IDurationFilterProps {
  value: string;
  withRange?: boolean;
  onChange: (option: IDurationOption) => void;
}

export const DurationFilter: React.FC<IDurationFilterProps> = ({
  value,
  withRange,
  onChange,
}) => {
  const options = withRange
    ? DURATION_OPTIONS.filter((option) => !!option.range)
    : DURATION_OPTIONS;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: "4px",
      }}
    >
      {options.map((option) => (
        <Tooltip key={option.id} title={option.tooltip}>
          <ToggleButton
            value={option.id}
            selected={value === option.id}
            onClick={() => onChange(option)}
            sx={{ flex: 1, minWidth: 0 }}
          >
            {option.label}
          </ToggleButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default DurationFilter;
